import axios from "axios";
import { ApiUrl, header } from "../../utils/modules";

class OffreServices {
  getAll() {
    return axios.get(ApiUrl + "offre", header());
  }

  getOne(id) {
    return axios.get(ApiUrl + `offre/${id}`, header());
  }

  create(data) {
    return axios.post(ApiUrl + "offre", data, header());
  }

  update(id, data) {
    return axios.put(ApiUrl + `offre/${id}`, data, header());
  }

  delete(id) {
    return axios.delete(ApiUrl + `offre/${id}`, header());
  }
}


export default new OffreServices();
